import { ResolveFn } from "@angular/router";
import { catchError, Observable, of, tap } from "rxjs";
import { IPendingOrderGetDTO } from "./models";
import { PendingOrderService } from "./pending-order.service";
import { inject } from "@angular/core";
import { TimeUtil } from "src/app/shared/services/time-util.service";
import { LoaderService } from "src/app/shared/components/loader/loader.service";

export const pendingOrderResolver: ResolveFn<
  Observable<IPendingOrderGetDTO[]>
> = (route, state) => {
  const pendingOrdSvc = inject(PendingOrderService);
  const timeUtil = inject(TimeUtil);
  const loaderService = inject(LoaderService);
  loaderService.show();
  return pendingOrdSvc
    .get({
      pullDate: timeUtil.formatDateLocalYYYYMMDD(
        new Date(timeUtil.getTomorrowDate())
      ),
    })
    .pipe(
      tap(() => {
        // Hide the loader once the data is fetched
        loaderService.hide();
      }),
      // Handle any errors that might occur during the data fetching
      catchError((error) => {
        loaderService.hide();
        console.error("Error fetching pending orders:", error);
        return of([]); // Return an empty list to avoid breaking the route
      })
    );
};
